import { baseApi } from './baseApi'
import { IIngredient } from '../../types/ingredients'
import { IIngredientParams } from '../../types/app'

export const ingredientsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getIngredients: builder.query<IIngredient[], void>({
      query: () => '/ingredients',
      providesTags: ['Ingredients'],
    }),
    createIngredient: builder.mutation<IIngredient, IIngredientParams>({
      query: (params) => ({
        url: '/ingredients',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Ingredients'],
    }),
    deleteIngredient: builder.mutation<void, string>({
      query: (id) => ({
        url: `/ingredients/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Ingredients'],
    }),
    editIngredient: builder.mutation<
      IIngredient,
      { params: IIngredientParams; id: string }
    >({
      query: ({ params, id }) => ({
        url: `/ingredients/${id}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: ['Ingredients'],
    }),
  }),
})

export const {
  useGetIngredientsQuery,
  useCreateIngredientMutation,
  useDeleteIngredientMutation,
  useEditIngredientMutation,
} = ingredientsApi
